import Vue from "vue";
import Vuex from "vuex";
import router from "./router";
import slugify from "slugify";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    search_value: "",
    selected_range: 5,
    gym_number_per_page: 10,
    notificationActive: false,
    free_pass_form_open: false,
    filterSidebar: false,
    facilities: undefined,
    sortByReview: false,
    gyms: [],
    gym: {},
    gymId: "",
    selectedPageNumber: 1,
    selected_free_pass_gym: {},
    numOfPages: 1,
    coronaNotif: true,
    gymApiStatus: "LOADED",
    gymsPerPage: 10,
    backToSearchButton: false,
    numOfGyms: 0,
  },
  mutations: {
    freeFormPassSwitch(state) {
      state.free_pass_form_open = !state.free_pass_form_open;
    },
    selectFreePassGym(state, selected_gym) {
      state.selected_free_pass_gym = selected_gym;
    },
    storeRange(state, range) {
      state.selected_range = range;
    },
    storeSearch(state, search_value) {
      state.search_value = search_value;
    },
    storeFacilities(state, facilities) {
      let toBeSelected = facilities.split(",");
      state.facilities.map((facility) => {
        if (toBeSelected.indexOf(facility.id.toString()) !== -1) {
          facility.selected = true;
        }
      });
    },
    storeGyms(state, gyms) {
      state.gyms = gyms;
    },
    storeGym(state, gym) {
      state.gym = gym;
    },
    storeTotalGymCount(state, value) {
      state.numOfGyms = value;
    },
    storeGymId(state, id) {
      state.gymId = id;
    },
    toggleNotification(state) {
      state.notificationActive = !state.notificationActive;
    },
    toggleSidebar(state) {
      state.filterSidebar = !state.filterSidebar;
    },
    setFacilities(state, facilities) {
      state.facilities = facilities;
    },
    toggleFacility(state, facility) {
      let index = state.facilities.indexOf(facility);
      state.facilities[index].selected = !state.facilities[index].selected;
    },
    toggleReviewSort(state) {
      state.sortByReview = !state.sortByReview;
    },
    incrementPageNumber(state) {
      state.selectedPageNumber++;
    },
    decrementPageNumber(state) {
      state.selectedPageNumber--;
    },
    storePageNumber(state, val) {
      state.selectedPageNumber = val;
    },
    storeNumOfPages(state, val) {
      state.numOfPages = val;
    },
    toggleCoronaNotif(state) {
      state.coronaNotif = false;
    },
    apiLoading(state) {
      state.gymApiStatus = "LOADING";
    },
    apiLoaded(state) {
      state.gymApiStatus = "LOADED";
    },
  },
  actions: {
    showNotification({ commit }) {
      commit("toggleNotification");
      setTimeout(() => {
        commit("toggleNotification");
      }, 3000);
    },
    showSidebar({ commit }) {
      commit("toggleSidebar");
    },
    toggleSortByReview({ dispatch, commit }) {
      commit("toggleReviewSort");
      dispatch("findGyms");
    },
    resetFacilities({ commit, dispatch, state }) {
      state.facilities.map((facility) => {
        if (facility.selected) {
          commit("toggleFacility", facility);
        }
      });
      dispatch("findGyms");
    },
    async findAllGyms({ commit }) {
      await this._vm.$http.get("/api/gyms").then((response) => {
        commit("storeGyms", response.data);
      });
    },
    async findGymById({ commit, state }) {
      await this._vm.$http.get(`/api/gyms/${state.gymId}`).then((response) => {
        state.gymNotFound = false;
        commit("storeGym", response.data);
      }).catch((error) => {
        console.error(error);
      });
    },
    async findGyms({ commit, state }) {
      try {
        commit("apiLoading");
        let facilityIds = [];
        if (state.facilities !== undefined) {
          state.facilities.map((facility) => {
            if (facility.selected) {
              facilityIds.push(facility.id);
            }
          });
          facilityIds = facilityIds.join(",");
        }
        await this._vm.$http.get(
          `/api/gyms/proximity/${state.search_value}/${
          state.selected_range
          }/?page=${state.selectedPageNumber}&items=${
          state.gymsPerPage
          }&facilities=${facilityIds}${
          state.sortByReview ? "&sort=review_avg" : ""
          }`
        )
          .then(({ data }) => {
            commit("storeGyms", data.gyms);
            commit("storeTotalGymCount", data.count)
            let numberOfPages = Math.ceil(data.count / state.gymsPerPage);
            if (numberOfPages) {
              commit("storeNumOfPages", numberOfPages);
            } else {
              commit("storeNumOfPages", 1);
            }
          })
          .catch(() => {
            commit("storeGyms", []);
          });
        router
          .push({
            name: "search",
            query: {
              search: slugify(state.search_value)
                .split("-")
                .join(""),
              page: state.selectedPageNumber,
              facilities: facilityIds.toString(),
            },
            params: {
              range: state.selected_range,
            },
          })
          .catch(() => { });
        commit("apiLoaded");
      } catch (error) {
        console.log(error);
      }
    },
    async addReferral(context, gymId) {
      await this._vm.$http.post(`/api/referrals/${gymId}`);
    },
  },
  getters: {
    facilities(state) {
      return state.facilities;
    },
    sortByReview(state) {
      return state.sortByReview;
    },
    hasGym(state) {
      return state.gym ? true : false;
    },
    numOfSelectedFacilities(state) {
      if(state.facilities){
        return state.facilities.filter((facility) => facility.selected).length;
      } else {
        return 0;
      }
    },
  },
});
